import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Spinner from '../../../../spinner'
import TaskDescription from './task-description'

const WordTask = function WordTask({
  wordTask,
  onResetTask,
  onSolveTask,
  onGetTask,
  postResetInterceptor,
  postSolveInterceptor,
}) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [newAnswer, setNewAnswer] = useState(``)
  const [solvingTask, setSolvingTask] = useState(false)
  const [taskLoaded, setTaskLoaded] = useState(true)
  const [lastActionIsRight, setLastActionIsRight] = useState(false)
  const [lastActionIsWrong, setLastActionIsWrong] = useState(false)

  const loadWordTask = interceptor => {
    return onGetTask(interceptor).then(value => {
      setNewAnswer(newAnswer || value.answer || '')
      setTaskLoaded(false)
      if (solvingTask) {
        setSolvingTask(false)
      }
      return value
    })
  }

  useEffect(() => {
    if (wordTask !== undefined && wordTask !== null) {
      setTaskLoaded(false)
      setLastActionIsRight(wordTask.lastActionIsRight)
      setLastActionIsWrong(wordTask.lastActionIsWrong)
      const { answer, resolved } = wordTask
      const chooseAnswer = resolved ? `` : answer || ``
      setNewAnswer(chooseAnswer)
    }
  }, [wordTask])

  const solveWordTask = () => {
    const { solved: previousSolveStatus } = wordTask
    onSolveTask(newAnswer).then(solveResult =>
      postSolveInterceptor(
        previousSolveStatus,
        solveResult,
        loadWordTask,
        newAnswer,
        setLastActionIsRight,
        setLastActionIsWrong,
        dispatch
      )
    )
  }

  useEffect(() => {
    if (solvingTask) {
      solveWordTask()
    }
  }, [solvingTask])

  const resetTask = () => {
    onResetTask()
      .then(() => {
        return loadWordTask(postResetInterceptor)
      })
      .then(() => {
        setLastActionIsRight(false)
        setLastActionIsWrong(false)
        setNewAnswer('')
      })
  }

  const handleChange = event => {
    setNewAnswer(event.target.value)
  }

  if (taskLoaded || wordTask === null) {
    return (
      <div className="task-loader">
        <Spinner />
      </div>
    )
  }

  const { description, resolved } = wordTask
  const disabled = newAnswer.length === 0
  let inputClassName = lastActionIsRight ? `lesson-input success` : `lesson-input error`
  let lessonClassName = lastActionIsRight ? `lesson-result success` : `lesson-result error`
  let message = lastActionIsRight ? `${t('TheRightSolution')}` : `${t('InvalidSolutionCheckAgain')}`
  let icon = lastActionIsRight ? <i className="mdi mdi-check" /> : <i className="mdi mdi-close" />

  if (!lastActionIsRight && !lastActionIsWrong) {
    inputClassName = `lesson-input`
    lessonClassName = `lesson-result`
    message = ``
    icon = null
  }

  if (resolved) {
    inputClassName = `lesson-input`
  }

  return (
    <div className="task-content">
      <div className="step-content-head">{t('AnswerLesson')}</div>
      <TaskDescription description={description} />
      <input
        type="text"
        className={inputClassName}
        style={{ color: `black` }}
        name="lesson-answer"
        onChange={handleChange}
        placeholder={t('EnterYourAnswer')}
        value={newAnswer || ''}
        disabled={lastActionIsRight && !resolved}
      />

      <div className="lesson-result-row">
        {resolved || solvingTask ? null : (
          <div className={lessonClassName}>
            {icon}
            <span>{message}</span>
          </div>
        )}
        <div className="lesson-result-right-wrap">
          <button type="button" className="reset-value-btn" style={{ cursor: 'pointer' }} onClick={() => resetTask()}>
            {t('ResetSolution')}
          </button>
          {solvingTask ? (
            <button type="button" disabled className="send-result-btn" style={{ cursor: 'pointer' }}>
              {t('SubmittingSolution')}
            </button>
          ) : (
            <button type="button" onClick={() => setSolvingTask(true)} className="send-result-btn" disabled={disabled}>
              {t('SubmitSolution')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default WordTask
